module.exports = __webpack_public_path__ + "static/media/ic_bano.a8518685.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_bano.webp
// module id = 169
// module chunks = 1